// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/" + (chunkId === 96 ? "vendors" : chunkId) + "." + {"96":"6171a914913c2e09c5d5","240":"c74112363eb40581a753"}[chunkId] + ".js";
};